import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import { CalibrationParticlePattern, ParticleCalibrationAudit, ParticlesCalibrationAuditFilter, ParticlesPatternFilter } from './particleCalibration';
import { ParticleCalibrationService } from '../services/particleCalibration.service';
import { CalibrationPatternService } from '../services/calibrationParticlesPattern.service';

export class ParticlesPatternDataSource implements DataSource<CalibrationParticlePattern> {

    private patternsSubject = new BehaviorSubject<CalibrationParticlePattern[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);
  
    public loading$ = this.loadingSubject.asObservable();
    public totalItems$ = this.totalSubject.asObservable();
  
    constructor(private service: CalibrationPatternService) {}
  
    connect(_collectionViewer: CollectionViewer): Observable<CalibrationParticlePattern[]> {
      return this.patternsSubject.asObservable();
    }
  
    disconnect(_collectionViewer: CollectionViewer): void {
      this.patternsSubject.complete();
      this.loadingSubject.complete();
      this.totalSubject.complete();
    }
  
    loadPatterns(calibrationId: number): void {
      this.loadingSubject.next(true);
  
      this.service.findAllById(calibrationId).pipe(
        catchError(() => of({ content: [], totalElements: 0 })),
        finalize(() => this.loadingSubject.next(false))
      ).subscribe(data => {
        if (data && data.content) {
          this.patternsSubject.next(data.content as CalibrationParticlePattern[]);
          this.totalSubject.next(data.totalElements as number);
        } else if (Array.isArray(data)) {
          this.patternsSubject.next(data);
          this.totalSubject.next(data.length);
        } else {
          this.patternsSubject.next([]);
          this.totalSubject.next(0);
        }
      });
    }

    addPattern(pattern: CalibrationParticlePattern): void {
        const current = this.patternsSubject.getValue();
        this.patternsSubject.next([...current, pattern]);
      }
    
    deletePattern(index: number): void {
        const currentPatterns = this.patternsSubject.getValue();
    
        if (index > -1 && index < currentPatterns.length) {
          currentPatterns.splice(index, 1);
          this.patternsSubject.next([...currentPatterns]);
          this.totalSubject.next(currentPatterns.length);
        }
    }

    updatePattern(updatedPattern: CalibrationParticlePattern): void {
        const current = this.patternsSubject.getValue();
        const index = current.findIndex(p => p.id === updatedPattern.id || (!p.id && p.idEquipment === updatedPattern.idEquipment));
      
        if (index !== -1) {
          current[index] = { ...updatedPattern };
          this.patternsSubject.next([...current]);
        }
      }
  }
